import View from '@shared/components/layout-default/layout-default-router-view';
import OperatorView from '@pbx/pages/operators';

export const groups = [
  {
    path: 'groups',
    component: OperatorView,
    children: [
      {
        path: '',
        name: 'pbx.group.index',
        component: () => import(/* webpackChunkName: 'pbx-groups' */ '@pbx/pages/operators/groups'),
        meta: {
          title: {
            code: 'pbx.breadcrumb.group.index'
          }
        }
      }
    ]
  },
  {
    path: 'groups',
    component: View,
    children: [
      {
        path: 'new',
        name: 'pbx.group.create',
        component: () =>
          import(
            /* webpackChunkName: 'pbx-groups' */
            '@pbx/pages/operators/groups/create'
          ),
        meta: {
          title: { code: 'pbx.breadcrumb.group.create' }
        }
      },

      {
        path: ':id([\\d]*)',
        name: 'pbx.group.edit',
        component: () =>
          import(
            /* webpackChunkName: 'pbx-groups' */
            '@pbx/pages/operators/groups/edit'
          ),
        meta: {
          title: {
            code: 'pbx.breadcrumb.group.edit'
          },
          loadable: true
        }
      }
    ]
  }
];
